// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopinSolutions_wrapper__1_YTE","title":"PopinSolutions_title__3d-Q0","list":"PopinSolutions_list__3Rz5x"};